// extracted by mini-css-extract-plugin
export default {"footerCard":"MainFooterCard_footerCard__VhKhD","footerCardTitle":"MainFooterCard_footerCardTitle__MHPET"};